import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Navbar from '@/components/Navbar';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function CheckoutSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    }
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    let attempts = 0;
    const maxAttempts = 5;

    const poll = async () => {
      if (attempts >= maxAttempts) {
        setStatus('timeout');
        return;
      }

      try {
        const response = await axios.get(`${API}/orders/status/${sessionId}`, { withCredentials: true });
        if (response.data.payment_status === 'paid') {
          setStatus('success');
        } else {
          attempts++;
          setTimeout(poll, 2000);
        }
      } catch (error) {
        setStatus('error');
      }
    };

    poll();
  };

  return (
    <div className="min-h-screen" style={{ background: "#cc5500" }}>
      <Navbar />
      <div className="max-w-2xl mx-auto px-4 py-24 text-center">
        {status === 'checking' && (
          <div>
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-sage-600 mx-auto mb-6"></div>
            <p className="text-xl text-sage-700">Confirming your payment...</p>
          </div>
        )}
        {status === 'success' && (
          <div className="fade-in" data-testid="success-message">
            <CheckCircle className="w-24 h-24 text-green-600 mx-auto mb-6" />
            <h1 className="text-4xl font-bold text-sage-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Order Confirmed!
            </h1>
            <p className="text-xl text-sage-700 mb-8">Thank you for your purchase. Your order is being prepared.</p>
            <div className="flex gap-4 justify-center">
              <Button onClick={() => navigate('/my-account')} className="bg-sage-600 hover:bg-sage-700">
                View Orders
              </Button>
              <Button variant="outline" onClick={() => navigate('/shop')}>
                Continue Shopping
              </Button>
            </div>
          </div>
        )}
        {status === 'error' && (
          <div>
            <p className="text-xl text-red-600">Payment verification failed. Please contact support.</p>
          </div>
        )}
      </div>
    </div>
  );
}
